import styled from 'styled-components';

export const StrongText = styled.strong`
    font-family: 'Sora', 'Barlow', BlinkMacSystemFont, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif;
    font-weight: 700;
`;